module.exports = __webpack_public_path__ + "img/B.Stat.66365543.svg";